import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.ts";
import Home from "../views/Home.vue";
import Gate from "../views/Gate.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            title: "Home Page"
        }
    },
    {
        path: "/gate",
        name: "Gate",
        component: () => {
            const options = store.getters.getPageOptions("gate");
            let gateComponent = options?.components;
            if (!gateComponent) {
                gateComponent = "Gate.vue";
            }
            return import(
                /* webpackChunkName: "Gate" */ `../views/${gateComponent}`
            );
        },
        meta: {
            title: "Portal to Meeting",
            noWrap: true
        },
        props: true,
        children: [
            {
                path: ":jwt",
                props: true,
                component: Gate
            }
        ]
    },
    {
        path: "/attendees",
        component: () =>
            import(
                /* webpackChunkName: "attendees" */ "../views/Attendees.vue"
            ),
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Attendees";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        },
        children: [
            {
                name: "Attendees",
                path: "",
                component: () => {
                    const options = store.getters.getPageOptions("attendees");
                    let searchComponent = options?.components?.search;

                    if (!searchComponent) {
                        searchComponent = "AttendeeSearch.vue";
                    }

                    return import(
                        /* webpackChunkName: "attendees" */ `../components/attendee-search/${searchComponent}`
                    );
                },
                meta: {
                    title: "Attendees"
                }
            },
            {
                name: "AttendeeSearchResults",
                path: "results",
                component: () =>
                    import(
                        /* webpackChunkName: "attendees" */ "../components/attendee-search/AttendeeSearchResults.vue"
                    ),
                meta: {
                    title: "Attendee Search Results"
                }
            },
            {
                path: "attendee-profile/:id",
                name: "attendeeProfile",
                props: true,
                component: () =>
                    import(
                        /* webpackChunkName: "attendeeProfile" */ "../components/attendee-profile/AttendeeProfile.vue"
                    ),
                meta: {
                    title: "Attendee Profile Page"
                }
            }
        ]
    },
    {
        path: "/sessions",
        name: "Sessions",
        meta: {
            title: "Sessions"
        },
        component: () =>
            import(
                /* webpackChunkName: "sessions" */ `../views/SessionsView.vue`
            ),
        // this will check if this route is active for navigation
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Sessions";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        }
    },
    {
        path: "/sessions/posters",
        name: "Posters",
        component: () =>
            import(
                /* webpackChunkName: "session" */ "../components/sessions/posters/PostersGridDisplay.vue"
            )
    },
    {
        path: "/sessions/:id",
        name: "Session",
        component: () =>
            import(/* webpackChunkName: "session" */ "../views/LiveStream.vue")
    },

    {
        path: "/meeting/:sessionId",
        name: "Meeting",
        meta: { noWrap: true },
        component: () =>
            import(/* webpackChunkName: "meeting" */ "../views/Meeting.vue")
    },
    {
        path: "/tradeshow",
        component: () =>
            import(
                /* webpackChunkName: "Tradeshow" */ "../views/Tradeshow.vue"
            ),
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Tradeshow";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        },
        children: [
            {
                name: "Tradeshow",
                path: "",
                component: () => {
                    const options = store.getters.getPageOptions("tradeshow");
                    let componentToUse = options?.components?.search;

                    if (!componentToUse) {
                        componentToUse = "search/ExhibitorSearch.vue";
                    }
                    return import(
                        /* webpackChunkName: "tradeshow" */ `../components/tradeshow/${componentToUse}`
                    );
                },
                meta: {
                    title: "Tradeshow"
                }
            },
            {
                path: "results",
                name: "ExhibitorSearchResults",
                component: () =>
                    import(
                        /* webpackChunkName: "tradeshow" */ "../components/tradeshow/search/ExhibitorSearchResults.vue"
                    ),
                meta: {
                    title: "Company Search Result"
                }
            },
            {
                path: "exhibitor-details/:id",
                name: "ExhibitorDetails",
                props: true,
                component: () =>
                    import(
                        /* webpackChunkName: "tradeshow" */ "../components/exhibitor-profile/ExhibitorExpandedProfile.vue"
                    ),
                meta: {
                    title: "Company profile page"
                }
            }
        ]
    },
    {
        name: "Resources",
        path: "",
        component: () =>
            import(
                /* webpackChunkName: "Resources" */ "../views/ResourcesView.vue"
            ),
        // this will check if this route is active for navigation
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Resources";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        },
        children: [
            {
                name: "resourceComponent",
                path: "/resources",
                component: () => {
                    const options = store.getters.getPageOptions("resources");
                    let componentToUse = options?.componentss;

                    if (!componentToUse) {
                        componentToUse = "Resources.vue";
                    }
                    return import(
                        /* webpackChunkName: "c" */ `../components/Resources/${componentToUse}`
                    );
                },
                meta: {
                    title: "Resources"
                }
            }
        ]
    },
    {
        name: "Presenters",
        path: "",
        component: () =>
            import(
                /* webpackChunkName: "Resources" */ "../views/PresentersView.vue"
            ),
        // this will check if this route is active for navigation
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Presenters";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        },
        children: [
            {
                name: "PresentersComponent",
                path: "/presenters",
                component: () => {
                    const options = store.getters.getPageOptions("presenters");
                    let componentToUse = options?.componentss;

                    if (!componentToUse) {
                        componentToUse = "Presenters.vue";
                    }
                    return import(
                        /* webpackChunkName: "c" */ `../components/Presenters/${componentToUse}`
                    );
                },
                meta: {
                    title: "Presenters"
                }
            }
        ]
    },
    {
        path: "/message-center",
        name: "Message-Center",
        meta: {
            title: "Message Center"
        },
        component: () =>
            import(
                /* webpackChunkName: "message-center" */ "../views/MessageCenterView.vue"
            ),
        // this will check if this route is active for navigation
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Message-Center";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        }
    },
    {
        path: "/admin",
        name: "Admin Panel",
        component: () =>
            import(
                /* webpackChunkName: "create-exhibitor" */ "../views/AdminHub.vue"
            ),
        children: [
            {
                path: "create-exhibitor",
                name: "Create Exhibitor",
                component: () =>
                    import(
                        /* webpackChunkName: "create-exhibitor" */ "../components/admin/profiles/CreateExhibitor.vue"
                    )
            },
            {
                path: "create-attendee",
                name: "Create Attendee",
                component: () =>
                    import(
                        /* webpackChunkName: "create-attendee" */ "../components/admin/profiles/CreateAttendee.vue"
                    )
            }
        ]
    },
    {
        name: "Schedule",
        path: "",
        component: () =>
            import(
                /* webpackChunkName: "Schedule" */ "../views/ScheduleView.vue"
            ),
        // this will check if this route is active for navigation
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Schedule";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        },
        children: [
            {
                path: "/schedule",
                name: "scheduleComponent",
                component: () => {
                    const options = store.getters.getPageOptions("schedule");
                    let componentToUse = options?.components?.landingPage;

                    if (!componentToUse) {
                        componentToUse = "schedule.vue";
                    }
                    return import(
                        /* webpackChunkName: "create-attendee" */ `../components/schedule/${componentToUse}`
                    );
                },
                meta: {
                    title: "Schedule"
                }
            }
        ]
    },
    {
        path: "/help",
        name: "Help",
        meta: {
            title: "Help"
        },
        component: () =>
            import(
                /* webpackChunkName: "create-attendee" */ "../views/HelpPage.vue"
            ),
        beforeEnter: (to: any, from: any, next: any) => {
            const activeRoute = store.getters.activeNavigation.filter(
                (chck: any) => {
                    return chck.name == "Help";
                }
            );

            if (activeRoute[0].active) {
                next();
            } else {
                next("/");
            }
        }
    },
    {
        path: "/live-stream/:id",
        name: "live stream",
        component: () =>
            import(
                /* webpackChunkName: "live-stream" */ "../views/LiveStream.vue"
            )
    },
    {
        path: "/mg-live",
        name: "StreamVideoLive",
        meta: {
            title: "Live Stream",
            noWrap: true
        },
        component: () => {
            const options = store.getters.getPageOptions("StreamVideoLive");
            let componentToUse = options.components;

            if (!componentToUse) {
                componentToUse = "StreamVideoLive.vue";
            }

            console.log(componentToUse);

            return import(
                /* webpackChunkName: "live-stream" */ `../views/${componentToUse}`
            );
        }
    },
    {
        path: "/meeting-fed",
        name: "Meeting fed",
        meta: {
            noWrap: true
        },
        component: () =>
            import(
                /* webpackChunkName: "meetingfed" */ "../views/MeetingFed.vue"
            )
    },
    {
        path: "/entrance",
        name: "Entrance",
        meta: {
            noWrap: true,
            title: "Embarking on a journey to your meeting..."
        },
        component: () =>
            import(
                /* webpackChunkName: "transitions" */ "../views/EntranceAnimation.vue"
            )
    },
    {
        path: "*",
        name: "Not Found",
        meta: {
            title: "Not Found"
        },
        component: () =>
            import(/* webpackChunkName: "meetingfed" */ "../views/NotFound.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach(async (to, from, next) => {
    const toRoute = to.matched.find((record) => to.name === record.name);

    // update page title
    document.title = to?.meta?.title || store.getters.conferenceName || "VMP";

    // handle app wrapper display
    if (toRoute?.meta?.noWrap) {
        store.dispatch("disableWrapper");
    } else {
        store.dispatch("enableWrapper");
    }

    // handle authentication
    if (
        store.state.themeConfig.forceAuth &&
        !store.getters.isAuthorized &&
        !to.path.startsWith("/gate")
    ) {
        localStorage.setItem("storedPath", to.path);
        return next({ path: "/gate" });
    }

    // this is last
    return next();
});

export default router;
